import { createDeepEqualSelector } from '.';
import { SearchGlobalStateType } from '../../types';

export const searchSortingSelector = (state: SearchGlobalStateType) =>
  state.searchSorting;

export const searchSortingListSelector = createDeepEqualSelector(
  searchSortingSelector,
  (searchSorting) => searchSorting.sortingList,
);

export const currentSortOptionSelector = createDeepEqualSelector(
  searchSortingSelector,
  (searchSorting) => searchSorting.currentSortOption,
);
